<script>
export default {
    name: 'Footer',
    components: {},
    computed: {},
    methods: {}
}
</script>

<template>
    <div class="footer">
        <div class="pagewrap">
            <div v-html="$t('template.footer')" class="footer-inner"/>
        </div>
    </div>
</template>

<style lang="scss">
@import "@/styles/variables/index";

.footer {
    margin-top: 100px;
    background-color: #7ccbc8;

    .pagewrap {
        // padding done by footer-inner
        padding: 0;
    }

    .footerOuterDiv {
       position: relative;
       height:400px;
       width: 300px;
    }

    .footerInnerDiv {
           margin: 0;
           position:absolute;
           top:50%;
           left: 50%;
        }

@include mobile() {
        margin-top: 64px;

        .footerOuterDiv {
            position: relative;
            height:300px;
            width: 200px;
            margin-top: -130px;
        }

        .footerInnerDiv {
           margin: 0;
           position:absolute;
           top:50%;
           left: 50%;
        }
    }

    @include tablet2() {
        margin-top: 64px;
         .footerOuterDiv {
            position: relative;
            height:300px;
            width: 600px;
            margin-top: -130px;
            margin-left: -200px;
        }

        .footerInnerDiv {
           margin: 0;
           position:absolute;
           top:50%;
           left: 50%;
        }
    }

    @include mobile-landscape-X() {
        margin-top: 64px;
    }
}

</style>
